<template>
   <footer class="mt-auto consulta-footer align-content-center align-middle clearfix">
      <div class="container pt-3 pb-3 align-items-center">
         <div class="row">
            <div class="col-xs-12 col-md-2">
               <a href="https://www.ine.mx/" target="_blank">
                  <img src="../assets/images/ine_logo_blanco.svg" class="center-logo-footer" />
               </a>
            </div>
            <div class="col-xs-12 col-md-8 text-center text-white">
               Sistema de Consulta del Portal de Rendición de Cuentas y Resultados de Fiscalización |
               <span>
                  <a href="https://crmcau.ine.mx/arsys/shared/login.jsp?/arsys/" target="_blank">
                     <span style="color: white">CAU</span>
                  </a>
               </span>
               <div>
                  <span>Compatibilidad óptima con Google Chrome</span>
               </div>
               <div>
                  <span
                     >© Derechos Reservados, Instituto Nacional Electoral, México 1991 al <span>{{ new Date().getFullYear() }}</span></span
                  >
               </div>
            </div>
            <div class="col-xs-12 col-md-2 text-center text-black">Rev43U 26042024.1100</div>
         </div>
      </div>
   </footer>
</template>
<script>
export default {
   name: "FooterComponent",
};
</script>
